export default function addValueToField(block) {
  block.fields.forEach((field) => {
    field.value = "";
  });
  block.blocks.forEach((b) => {
    addValueToField(b);
  });
}
